/** TanStack Query hook for fetching plugin parameter definitions. */

import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";
import type { Plugin, ParameterDef } from "@/types";

/**
 * Fetches plugin metadata and extracts parameter definitions for a given pluginId.
 *
 * When pluginId is null/undefined the query is disabled (no network request).
 * Returns the parameter definitions array, loading state, and any error.
 */
export function usePluginParameters(pluginId: string | null | undefined) {
  const query = useQuery<Plugin, Error, ParameterDef[]>({
    queryKey: ["plugin", pluginId, "parameters"],
    queryFn: () => api.get<Plugin>(`/reporting/plugins/${pluginId}`),
    enabled: !!pluginId,
    select: (plugin) => plugin.parameters ?? [],
  });

  return {
    parameters: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
  };
}
